// Generated by https://pagedraw.io/pages/12008
import React from 'react';
import './statelessbutton.css';


export default class Statelessbutton extends React.Component {
  render() {
    return (
      <div onClick={((e) => this.props.onClick(e))} className="statelessbutton-statelessbutton-8">
          <div className="statelessbutton-0">
              <div className="statelessbutton-buttonstateless-8">
                  <div className="statelessbutton-0-0-0">
                      <div className="statelessbutton-statelesstext-2">
                          { this.props.buttonText }
                      </div>
                  </div>
              </div>
          </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/pagedraw/statelessbutton.js